export const FETCH_EXPENSE_ENTITY_TAGS = 'FETCH_EXPENSE_ENTITY_TAGS'
export const FETCH_EXPENSE_ENTITY_TAGS_FAILED = 'FETCH_EXPENSE_ENTITY_TAGS_FAILED'
export const FETCH_EXPENSE_ENTITY_TAGS_SUCCEEDED = 'FETCH_EXPENSE_ENTITY_TAGS_SUCCEEDED'
